// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27white%27%3e%3cpath d=%27M7 10l5 5 5-5z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Management Layout */
.management-container {
  padding: 0.5rem 2rem 2rem 2rem;
  background-color: #011029;
  min-height: calc(100vh - 64px - 1rem);
  width: 100%;
}

.management-nav {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.nav-tab {
  padding: 0.75rem 1.5rem;
  color: white;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s;
}

.nav-tab:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-tab.active {
  background-color: #2196F3;
}

.data-container {
  width: 100%;
  padding: 0;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table tr {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.data-table th {
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}

.data-table td {
  color: white;
  background: inherit;
}

.data-table button {
  background: none;
  border: none;
  color: #f44336;
  cursor: pointer;
  padding: 0.5rem;
}

.data-table button:hover {
  background-color: rgba(244, 67, 54, 0.1);
  border-radius: 4px;
}

.data-table input {
  background: inherit;
}

.editable-name {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.editable-name:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.name-input {
  width: 100%;
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: inherit;
  outline: none;
}

.name-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.status-badge {
  border: none;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  width: 100px;
  text-transform: capitalize;
}

.status-badge.active {
  background-color: #4caf50;
  color: white;
}

.status-badge.inactive {
  background-color: #f44336;
  color: white;
}

.location-select {
  min-width: 200px;
}

.select__control {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.select__menu {
  background-color: #2a2a2a !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.select__option {
  background-color: transparent !important;
  color: white !important;
}

.select__option--is-focused {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.select__multi-value {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.select__multi-value__label {
  color: white !important;
}

.password-change-btn {
  padding: 6px 12px;
  background-color: #4a5568;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.password-change-btn:hover {
  background-color: #2d3748;
}

.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-toggle {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  color: #718096;
  cursor: pointer;
  padding: 0;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

.submit-btn, .cancel-btn {
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}

.submit-btn {
  background-color: #48bb78;
  color: white;
}

.cancel-btn {
  background-color: #718096;
  color: white;
}

.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
}

.delete-button {
  padding: 6px;
  background-color: #e53e3e;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-button:hover {
  background-color: #c53030;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: #1a1a1a;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h3 {
  margin: 0;
  color: #fff;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
}

.close-button:hover {
  color: #fff;
}

.modal-error {
  background-color: #dc3545;
  color: white;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.type-select {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  width: 160px;
  transition: all 0.2s ease;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 20px;
  padding-right: 32px;
}

.type-select:hover {
  border-color: rgba(255, 255, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.15);
}

.type-select:focus {
  outline: none;
  border-color: #2196F3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);
}

.type-select option {
  background-color: #011029;
  color: white;
  padding: 8px;
}

.add-btn {
  background-color: #2196F3;
  color: white;
  border: none;
  padding: 8px 16px;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 1rem 0;
  font-size: 14px;
}

.add-btn svg {
  font-size: 14px;
}

.add-btn:hover {
  background-color: #1976D2;
}

.description-input {
  width: 100%;
  padding: 8px;
  border: none;
  background: transparent;
  font-size: 14px;
  transition: all 0.3s;
}

.description-input:focus {
  outline: none;
  background: transparent;
}

.description-input::placeholder {
  color: #999;
}`, "",{"version":3,"sources":["webpack://./src/components/manage/Management.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yDAA+K;EAC/K,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* Management Layout */\n.management-container {\n  padding: 0.5rem 2rem 2rem 2rem;\n  background-color: #011029;\n  min-height: calc(100vh - 64px - 1rem);\n  width: 100%;\n}\n\n.management-nav {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.nav-tab {\n  padding: 0.75rem 1.5rem;\n  color: white;\n  background: none;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.2s;\n}\n\n.nav-tab:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.nav-tab.active {\n  background-color: #2196F3;\n}\n\n.data-container {\n  width: 100%;\n  padding: 0;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.data-table tr {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.data-table th {\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.7);\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  letter-spacing: 0.5px;\n}\n\n.data-table td {\n  color: white;\n  background: inherit;\n}\n\n.data-table button {\n  background: none;\n  border: none;\n  color: #f44336;\n  cursor: pointer;\n  padding: 0.5rem;\n}\n\n.data-table button:hover {\n  background-color: rgba(244, 67, 54, 0.1);\n  border-radius: 4px;\n}\n\n.data-table input {\n  background: inherit;\n}\n\n.editable-name {\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.editable-name:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.name-input {\n  width: 100%;\n  padding: 4px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: inherit;\n  outline: none;\n}\n\n.name-input:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.status-badge {\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  transition: all 0.3s ease;\n  width: 100px;\n  text-transform: capitalize;\n}\n\n.status-badge.active {\n  background-color: #4caf50;\n  color: white;\n}\n\n.status-badge.inactive {\n  background-color: #f44336;\n  color: white;\n}\n\n.location-select {\n  min-width: 200px;\n}\n\n.select__control {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  border-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.select__menu {\n  background-color: #2a2a2a !important;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.select__option {\n  background-color: transparent !important;\n  color: white !important;\n}\n\n.select__option--is-focused {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.select__multi-value {\n  background-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.select__multi-value__label {\n  color: white !important;\n}\n\n.password-change-btn {\n  padding: 6px 12px;\n  background-color: #4a5568;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  white-space: nowrap;\n}\n\n.password-change-btn:hover {\n  background-color: #2d3748;\n}\n\n.password-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 8px;\n  background: none;\n  border: none;\n  color: #718096;\n  cursor: pointer;\n  padding: 0;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.submit-btn, .cancel-btn {\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n}\n\n.submit-btn {\n  background-color: #48bb78;\n  color: white;\n}\n\n.cancel-btn {\n  background-color: #718096;\n  color: white;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.delete-button {\n  padding: 6px;\n  background-color: #e53e3e;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-button:hover {\n  background-color: #c53030;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background-color: #1a1a1a;\n  border-radius: 8px;\n  padding: 20px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #fff;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #666;\n  cursor: pointer;\n}\n\n.close-button:hover {\n  color: #fff;\n}\n\n.modal-error {\n  background-color: #dc3545;\n  color: white;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.type-select {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  width: 160px;\n  transition: all 0.2s ease;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  background-size: 20px;\n  padding-right: 32px;\n}\n\n.type-select:hover {\n  border-color: rgba(255, 255, 255, 0.3);\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n.type-select:focus {\n  outline: none;\n  border-color: #2196F3;\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);\n}\n\n.type-select option {\n  background-color: #011029;\n  color: white;\n  padding: 8px;\n}\n\n.add-btn {\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  height: 36px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 1rem 0;\n  font-size: 14px;\n}\n\n.add-btn svg {\n  font-size: 14px;\n}\n\n.add-btn:hover {\n  background-color: #1976D2;\n}\n\n.description-input {\n  width: 100%;\n  padding: 8px;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  transition: all 0.3s;\n}\n\n.description-input:focus {\n  outline: none;\n  background: transparent;\n}\n\n.description-input::placeholder {\n  color: #999;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
